import React from 'react'
import { observer } from 'mobx-react-lite'
import useUniversityExplorationSubmission from './hooks/useUniversityExplorationSubmission'
import s from './styles/UniversityExplorationSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const UniversityExplorationSubmission = observer(({ assignment, student }) => {
	const { universitiesByCountry, isLoading, responseText, hasResponse } =
		useUniversityExplorationSubmission({
			assignment,
			student,
		})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>

					{isLoading ? (
						<div className={sharedStyles.loading}>Loading universities...</div>
					) : universitiesByCountry && universitiesByCountry.length > 0 ? (
						universitiesByCountry.map((countryGroup, index) => (
							<div
								key={`country-${index}-${countryGroup.countryName}`}
								className={sharedStyles.section}
							>
								<span className={sharedStyles.section__title}>
									Selected Universities under {countryGroup.countryName}
								</span>
								<div className={sharedStyles.badgesList}>
									{countryGroup.universities.map((university, uniIndex) => {
										const universityName =
											typeof university === 'string'
												? university
												: university?.name ||
													university?.universityName ||
													university?.title ||
													'Unknown University'
										return (
											<span
												key={`university-${index}-${uniIndex}-${universityName}`}
												className={sharedStyles.badge}
											>
												{universityName}
											</span>
										)
									})}
								</div>
							</div>
						))
					) : (
						<div className={sharedStyles.empty}>
							No universities have been selected yet
						</div>
					)}

					<div className={sharedStyles.section}>
						<span className={sharedStyles.section__title}>
							Student's Response
						</span>
						<div className={sharedStyles.textArea}>
							{hasResponse ? (
								<p className={sharedStyles.textContent}>{responseText}</p>
							) : (
								<div className={sharedStyles.empty}>
									No response submitted yet
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})

UniversityExplorationSubmission.displayName = 'UniversityExplorationSubmission'

export default UniversityExplorationSubmission
